import React from "react";
import { Landmark, Loader2, Menu, RefreshCw } from "lucide-react";
import { useAdminLayout } from "../AdminLayoutContext";

export default function AdminTreasuryChrome({
  loading,
  onRefresh,
  onRecordBalance,
  recording,
}) {
  const { openMobileMenu } = useAdminLayout();

  return (
    <>
      <header className="am-chrome">
        <div className="am-chrome-row">
          <div className="am-chrome-lead">
            <button
              type="button"
              className="am-chrome-btn am-chrome-btn-icon lg:hidden"
              onClick={openMobileMenu}
              aria-label="Open menu"
            >
              <Menu size={16} strokeWidth={2.2} />
            </button>

            <div className="am-chrome-brand" aria-label="Treasury analytics">
              <Landmark size={12} strokeWidth={2.3} aria-hidden />
              <span>Treasury</span>
            </div>
          </div>

          <div className="am-chrome-trail">
            <button
              type="button"
              className="am-chrome-btn am-chrome-btn-icon"
              onClick={onRefresh}
              disabled={loading || recording}
              aria-label="Refresh"
              title="Refresh"
            >
              {loading ? (
                <Loader2 size={14} className="am-spin" aria-hidden />
              ) : (
                <RefreshCw size={14} strokeWidth={2.3} aria-hidden />
              )}
            </button>
            <button
              type="button"
              className="am-chrome-btn am-chrome-btn-accent"
              onClick={onRecordBalance}
              disabled={loading || recording}
            >
              {recording ? (
                <Loader2 size={14} className="am-spin" aria-hidden />
              ) : (
                <RefreshCw size={14} strokeWidth={2.3} aria-hidden />
              )}
              Record float
            </button>
          </div>
        </div>
      </header>
      <div className="atrs-chrome-tail">
        <div className="am-chrome-spacer" aria-hidden />
      </div>
    </>
  );
}
